/**
 * Created by sagardesai on 05/07/18..
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../actions/index';
import * as _ from 'lodash'
import ContentLoader from "react-content-loader"
import {getEncryptedIdForBroadcaster} from "../util/broadcast_util"
//image
import icon_following from "../assets/images/icon_following.png"
import icon_following_active from "../assets/images/icon-following-active.png"
import icon_users from "../assets/images/icon_users@2x.png"
import online from "../assets/images/icon-vuepay-blue@2x.png"
import icon_credit_card from "../assets/images/icon_credit_card.png"

class SimilarBroadcasters extends Component {

    constructor(props) {
        super(props)

        if (props.hasOwnProperty("broadcaster_detail_management") &&
            props.broadcaster_detail_management.hasOwnProperty("similarBroadcasters") &&
            props.broadcaster_detail_management.similarBroadcasters != null &&
            props.broadcaster_detail_management.similarBroadcasters.hasOwnProperty("data")) {
            this.state = {
                similarBroadcasters: props.broadcaster_detail_management.similarBroadcasters.data.data
            }
        }
        else {
            this.props.history.push("/dashboard")
            this.state = {
                similarBroadcasters: []
            }
        }

    }

    onClickOfBroadcast = (broadcaster_id) => (e) => {
        this.props.history.push(`/broadcast/${getEncryptedIdForBroadcaster(broadcaster_id)}`);
    }

    render() {

        return (
            <div>
                <main role="main" className="">
                    <div className="broadcast-container">
                        <div className="title-container">

                            <div>
                                <h4>Similar Broadcasters
                                    {this.state.similarBroadcasters.length > 0 &&
                                    <span> ({this.state.similarBroadcasters.length})</span>}
                                </h4>
                            </div>
                        </div>
                        {this.props.broadcaster_detail_management.isFetching && this.state.similarBroadcasters.length === 0 &&
                        <ContentLoader
                            height={240}
                            speed={1}
                            primaryColor="#f3f3f3"
                            secondaryColor="#ecebeb">

                            <rect x="10" y="20" rx="4" ry="4" width="70" height="40"/>
                            <rect x="10" y="65" rx="4" ry="4" width="70" height="5"/>
                            <rect x="10" y="75" rx="4" ry="4" width="70" height="5"/>

                            <rect x="90" y="20" rx="4" ry="4" width="70" height="40"/>
                            <rect x="90" y="65" rx="4" ry="4" width="70" height="5"/>
                            <rect x="90" y="75" rx="4" ry="4" width="70" height="5"/>

                            <rect x="170" y="20" rx="4" ry="4" width="70" height="40"/>
                            <rect x="170" y="65" rx="4" ry="4" width="70" height="5"/>
                            <rect x="170" y="75" rx="4" ry="4" width="70" height="5"/>

                        </ContentLoader>
                        }
                        <div className="row">

                            {
                                this.state.similarBroadcasters && this.state.similarBroadcasters.length > 0 && _.map(this.state.similarBroadcasters, (data) => {

                                    return <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4"
                                                style={{cursor: 'pointer'}} key={data.id}
                                                onClick={this.onClickOfBroadcast(data.id)}>

                                        <div className="broadcast-wrapper followers-wrapper">
                                            <div className="followers-img">
                                                <img src={data.channel_image_square} alt="followers"/>
                                            </div>
                                            {data.is_following &&
                                            <div className="followers-icon"><img src={icon_following_active}
                                                                                 alt="Followers"/></div>}
                                            <div className="broadcast-content">
                                                <p className="font-weight-bold">{data.username}
                                                    {
                                                        data.status === "online" &&
                                                        <span className="online"><img src={online} alt="Online"/></span>

                                                    }

                                                </p>
                                                {
                                                    data.status === "online" && data.broadcast.length > 0 ?
                                                        <p className="small hits">
                                                            {data.broadcast.length > 0 && data.broadcast[0].broadcast_type === "paid" &&
                                                            <a href="" title="Credit Card"><img src={icon_credit_card}
                                                                                                alt="Credit Card"/></a>}
                                                            <a href="" title="Following"><img src={icon_following}
                                                                                              alt="Following"/></a>
                                                            <a href="" title="Users"><img src={icon_users} alt="Users"/></a>
                                                            <span>{data.followers_count}</span>
                                                        </p>
                                                        :
                                                        <p className="small hits">
                                                            <span>
                                                                {data.status === "online" && data.broadcast.length === 0 ? "Online" : "Offline"}
                                                            </span>

                                                        </p>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                })
                            }


                        </div>
                        {
                            this.state.similarBroadcasters && this.state.similarBroadcasters.length === 0 &&
                            <div style={{textAlign: 'center', marginTop: '100px'}}>
                                <p>Sorry, No similar broadcasters at the moment. Maybe follow a broadcaster?</p>
                            </div>
                        }
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        account_management: state.account_management,
        broadcaster_detail_management: state.broadcaster_detail_management
    };
}

export default connect(mapStateToProps, actions)(SimilarBroadcasters);